import { render } from "./FamilySection.vue?vue&type=template&id=2f327e22&scoped=true"
import script from "./FamilySection.vue?vue&type=script&lang=js"
export * from "./FamilySection.vue?vue&type=script&lang=js"

import "./FamilySection.vue?vue&type=style&index=0&id=2f327e22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f327e22"]])

export default __exports__